import { BaseLegalEntityFormFieldNames } from 'shared/enums/baseLegalEntityFormFieldNames';
import { BaseLegalEntityFormValues } from 'features/new-actor/types/baseLegalEntityFormValues';
import * as Yup from 'yup';
import { ValidationRules } from 'helpers/createFormConfig';

export const baseLegalEntityValidationRules: ValidationRules<keyof BaseLegalEntityFormValues> =
{
  [BaseLegalEntityFormFieldNames.LegalReason]: Yup.string()
    .trim()
    .required('Ce champ est requis'),

  [BaseLegalEntityFormFieldNames.RegistrationNumber]: Yup.string()
    .required('Ce champ est requis')
    .matches(
      /^\d{3}\s?\d{3}\s?\d{3}\s?\d{5}$/,
      'Veuillez entrer un numéro de SIRET valide.'
    ),

  [BaseLegalEntityFormFieldNames.RcsNumber]: Yup.string()
    .trim()
    .required('Ce champ est requis')
    .matches(/^\d+$/, 'Ce champ doit être un nombre'),

  [BaseLegalEntityFormFieldNames.OriasNumber]: Yup.string()
    .trim()
    .matches(/^\d+$/, 'Ce champ doit être un nombre'),

  [BaseLegalEntityFormFieldNames.RcsCity]: Yup.string()
    .trim()
    .required('Ce champ est requis')
    .min(2, 'Doit contenir au moins 2 caractères')
    .max(100, 'Ne peut pas dépasser 100 caractères'),

  [BaseLegalEntityFormFieldNames.Capital]: Yup.number()
    .required('Le capital est requis')
    .min(1, 'Le capital doit être supérieur à 0')
    .typeError('Le capital doit être un nombre'),

  [BaseLegalEntityFormFieldNames.Rcp]: Yup.string()
    .trim()
    .min(2, 'Ce champ doit contenir au moins 2 caractères'),
};
